import React, { Fragment, ReactNode } from 'react';

import { extractSpoilers } from 'common/spoilers/utils';
import insertBr from 'common/tools/react/insertBr';

type ReviewTextProps = {
  text?: string;
};

const createTextElement = (text: string, index: number): ReactNode => (
  <Fragment key={index}>{insertBr(text)}</Fragment>
);

const createSpoilerElement = (text: string, index: number): ReactNode => (
  <span key={index} className="spoiler-container">
    <span className="spoiler-header">spoiler</span>
    <span className="spoiler-content">{insertBr(text)}</span>
  </span>
);

const createElements = (text: string): ReactNode[] => {
  if (!text) return [];

  const { textParts, spoilerParts } = extractSpoilers(text);
  const elements: ReactNode[] = [];
  const totalLength = textParts.length + spoilerParts.length;

  let textIndex = 0;
  let spoilerIndex = 0;

  for (let i = 0; i < totalLength; i++) {
    const isSpoiler = i % 2 === 1;
    elements.push(
      isSpoiler
        ? createSpoilerElement(spoilerParts[spoilerIndex++], i)
        : createTextElement(textParts[textIndex++], i)
    );
  }

  return elements;
};

const ReviewText: React.FC<ReviewTextProps> = ({ text = '' }) =>
  createElements(text);

export default ReviewText;
